import React from 'react';
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import {removeToken} from '../../store/actions/token';
import RemoveCookie from '../../Utils/Cookies/RemoveCookie';
import {NavDropDownMenu} from '../../components';

const NavBar = ({tokenObject,removeToken}) => {


    function handleLogOut(){
        removeToken();
        RemoveCookie('token');
    }

    const ContentList = [
        {
            name:"All Contents",
            linkTo:"/Contents"
        },
        {
            name:"My Contents",
            linkTo:"/MyContents"
        },
        {
            name:"Add Content",
            linkTo:"/AddContent"
        },
    ];

    const TaskList = [
        {
            name:"All Tasks",
            linkTo:"/Tasks"
        },
        {
            name:"Add Task",
            linkTo:"/AddTask"
        }
    ];

    return(
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
            <div className="container-fluid">
            <Link to="/Home" className="navbar-brand" href="#">Biblioteca ADS</Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                {(function openContentTabs(){

                        if(tokenObject.token.length !== 0){
                            return(
                                <>
                                    <NavDropDownMenu name="Content" links={ContentList}/>
                                    <NavDropDownMenu name="Tasks" links={TaskList}/>
                                    <li className="nav-item">
                                        <Link to="/Profile" className="nav-link" href="#">Profile</Link>
                                    </li>      
                                </>
                            );
                        }else{
                            return(
                            <>

                            </>);
                        }
                    })()
                }
                </ul>
                {(function openLogin(){
                    if(tokenObject.token == 0){
                        return(
                        <div className="d-flex">
                            <Link to="/Login">
                                <button className="btn btn-success me-2" type="button">Login</button>
                            </Link>
                            <Link to="/Signin">
                                <button className="btn btn-outline-success me-2" type="button">Sign in</button>
                            </Link>
                        </div>)
                    }else{
                        return(
                            <>             
                                <button className="btn btn-outline-danger me-2" type="button" onClick={handleLogOut}>Log out</button>
                            </>
                        );
                    }
                })()}
                
            </div>
        </div>
        </nav>
    );
}

const mapStateToProps = (state) => ({
    tokenObject: state.token
});

export default connect(mapStateToProps,{removeToken})(NavBar);